"use client";

import { c as _c } from "react/compiler-runtime";
import { type FC, startTransition, useEffect } from "react";
import { useRouter } from "next/navigation";
import { Inter } from "next/font/google";
import posthog from "posthog-js";
import { faTriangleExclamation } from "@fortawesome/pro-duotone-svg-icons";
import { PrimaryButton } from "~/client/components/buttons/PrimaryButton";
import { Icon } from "~/client/components/widgets/Icon";
import { emailGlobalErrorNotice } from "~/client/services/functions/email";
import { ErrorRegistry } from "~/shared/errors/registry";
import type { ErrorPageProps } from "~/types";
import "./global-error.scss";
const inter = Inter({
  subsets: ["latin"],
  weight: ["300", "400", "500", "600", "700", "800"],
  display: "swap"
});
const RSC_GENERIC_MESSAGE = "An error occurred in the Server Components render";
const RootErrorLayout: FC<ErrorPageProps> = t0 => {
  const $ = _c(16);
  const {
    error,
    reset
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== reset || $[1] !== router) {
    t1 = () => {
      startTransition(() => {
        router.refresh();
        reset();
      });
    };
    $[0] = reset;
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleReset = t1;
  let t2;
  let t3;
  if ($[3] !== error) {
    t2 = () => {
      posthog.captureException(error, {
        Cause: error.cause,
        Digest: error.digest,
        Message: error.message,
        Name: error.name,
        "Stack Trace": error.stack
      });
      emailGlobalErrorNotice(error).then(_temp);
    };
    t3 = [error];
    $[3] = error;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <head />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h2 className="global-error__title"><Icon icon={faTriangleExclamation} /></h2>;
    t6 = <h1 className="global-error__subtitle">Something went wrong!</h1>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  const t7 = error.message.includes(RSC_GENERIC_MESSAGE) && "code" in error ? ErrorRegistry[error.code as keyof typeof ErrorRegistry].message : "An unexpected error occurred. Please try again.";
  let t8;
  if ($[9] !== t7) {
    t8 = <p className="global-error__message">{t7}</p>;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== handleReset) {
    t9 = <div className="global-error__actions"><PrimaryButton onClick={handleReset} type="button">Try again</PrimaryButton></div>;
    $[11] = handleReset;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t8 || $[14] !== t9) {
    t10 = <html lang="en" className={inter.className}>{t4}<body><div className="global-error"><div className="global-error__container"><div className="global-error__content">{t5}{t6}{t8}{t9}</div></div></div></body></html>;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
};
export default RootErrorLayout;
function _temp(error_0) {
  return error_0 && console.error(error_0);
}